import { render, staticRenderFns } from "./LocationTopbar.vue?vue&type=template&id=8b1b5be0&scoped=true"
import script from "./LocationTopbar.vue?vue&type=script&lang=js"
export * from "./LocationTopbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1b5be0",
  null
  
)

export default component.exports